import React, { useEffect } from "react";
import { withNamespaces } from "react-i18next";
import Select from "react-select";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { AddJobPositionSchema } from "../../utils/validators/addJobpositionValidation";
import CustomInput from "../../components/CustomeInput";
import { handleKeyDown } from "../../utils/common/inputValidation";
import CustomTextArea from "../../components/CustomeTextarea";
import {
  getEducationalOptions,
  getForeignLangugeOptions,
  getLocation,
  getSpecialRequiremntOptions,
  getUnit,
  getrequiredKnowledgeAndSkilloptions,
  jobPostionGetByid,
  orgAddJobPosition,
  orgStructure,
  updateJobPostion,
  getAvailableJobPositions,
} from "../../Api/services/org-StructureService";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../components/Loader";
import Spinner from "../../components/Spinner";
import {
  customStylesDropdown,
  handleKeyDownforPositiveNumber,
  mapDropdownOptions,
} from "../../utils/common/commonFunction";

function AddJobPosition({ onClose, editmode, jobPostionId: jobPositionId, t }) {
  const schema = AddJobPositionSchema(t);
  const dispatch = useDispatch();
  //redux state data
  const {
    loading,
    jobpostionloaidng,
    locationOptions,
    unitOptions,
    specialRequirmentOptionsData,
    skilOptionsData,
    eduactionQulificationData,
    foreignLangugeData,
    availableJobPositionOptions,
  } = useSelector((state) => state?.orgStructure);
  // Initialize react-hook-form useForm hook with Yup resolver
  const {
    control,
    handleSubmit,
    formState: { errors },
    getValues,
    setValue,
    watch,
  } = useForm({
    resolver: yupResolver(schema),
  });
  //form submit event
const onSubmit = async (data) => {
  const formattedData = {
    ...data,
    serial_number: 10,
    work_experience: parseInt(data?.work_experience, 10),
    allocated_number_of_employees: parseInt(
      data?.allocated_number_of_employees,
      10
    ),
    minimum_number_of_employees: parseInt(
      data?.minimum_number_of_employees,
      10
    ),
    violation_timeout: data?.violation_timeout
      ? parseInt(data.violation_timeout, 10)
      : null,
  };

  if (
    data.parent_id &&
    data.parent_id !== "00000000-0000-0000-0000-000000000000"
  ) {
    formattedData.parent_id = data.parent_id;
  } else {
    delete formattedData.parent_id;
  }

  let result;
  if (editmode && jobPositionId) {
    result = await dispatch(
      updateJobPostion({ id: jobPositionId, data: formattedData })
    );
  } else {
    result = await dispatch(orgAddJobPosition(formattedData));
  }

  if (result?.payload && result.payload.success === true) {
    onClose();
    dispatch(orgStructure({ search_text: "", location_id: "" }));
  }
};

  //get by id call api
  const getbyIdApicall = async () => {
    if (editmode && jobPositionId) {
      const result = await dispatch(
        jobPostionGetByid({ id: jobPositionId, data: "" })
      );
      if (result?.payload && result.payload.success === true) {
        //deafult set of filed value
        const data = result?.payload?.data;
        setValue("serial_number", data?.system_id);
        setValue("abbreviation", data?.abbreviation);
        setValue("difficulty_coefficient", data?.difficulty_coefficient);
        setValue("work_experience", data?.work_experience);
        setValue("name", data?.name);
        setValue(
          "required_knowledge_and_skill_id",
          data?.required_knowledge_and_skill_id
        );
        setValue(
          "allocated_number_of_employees",
          data?.allocated_number_of_employees
        );
        setValue(
          "minimum_number_of_employees",
          data?.minimum_number_of_employees
        );
        setValue("special_requirement_id", data?.special_requirement_id);
        setValue("unit_id", data?.unit_id);
        setValue("location_id", data?.location_id);
        setValue("parent_id", data?.parent_id);
        setValue("foreign_language_id", data?.foreign_language_id);
        setValue(
          "educational_qualification_id",
          data?.educational_qualification_id
        );
        setValue("description", data?.description);
      }
    }
  };
  //call function job postion id
  useEffect(() => {
    getbyIdApicall();
  }, [editmode, jobPositionId]);
  // Sequential API calls
  const fetchDropdownOptionsSequentially = async () => {
    await dispatch(getUnit());
    await dispatch(getLocation());
    await dispatch(
      getSpecialRequiremntOptions({ type: "special_requirement" })
    );
    await dispatch(
      getrequiredKnowledgeAndSkilloptions({
        type: "required_knowledge_and_skill",
      })
    );
    await dispatch(
      getEducationalOptions({ type: "educational_qualification" })
    );
    await dispatch(getForeignLangugeOptions({ type: "foreign_language" }));
  };

  const fetchAvailableJobPositions = async (payload) => {
    await dispatch(getAvailableJobPositions(payload));
  };

  const orgUnitID = watch("unit_id");

  useEffect(() => {
    if (!orgUnitID) return;

    fetchAvailableJobPositions({
      unit_id: orgUnitID,
      job_position_id: jobPositionId,
    });
  }, [orgUnitID, jobPositionId]);

  //get options of dropdown
  useEffect(() => {
    fetchDropdownOptionsSequentially();
  }, [dispatch]);

  // Create options using location data location
  const locationDropdownOptions =
    locationOptions?.data?.locations.map((location) => ({
      value: location.id,
      label: location.name,
    })) || [];

  // Create options using unit data for unit dropdown
  const unitDropdownOptions =
    unitOptions?.map((unit) => ({
      value: unit.id,
      label: unit.name,
    })) || [];

  // Create options using job position data for dropdown
  const jobPositionDropdownOptions = mapDropdownOptions(
    availableJobPositionOptions,
    "name",
    t
  );

  //call common function and genrate options
  const specialRequirmentOptions = mapDropdownOptions(
    specialRequirmentOptionsData,
    t
  );
  const skilOptions = mapDropdownOptions(skilOptionsData, t);
  const eduactionQulificationOptions = mapDropdownOptions(
    eduactionQulificationData,
    t
  );
  const foreignLangugeOptions = mapDropdownOptions(foreignLangugeData, t);

  if (jobpostionloaidng) {
    return <Spinner size="md" color="#C77025" />;
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="flex lg:flex-row flex-col 2xl:mt-5 mt-3 2xl:gap-5 gap-3">
        <div className="lg:w-6/12 w-full">
          <div className="flex lg:flex-row flex-col 2xl:gap-5 gap-3">
            {editmode && (
              <div className="lg:w-6/12 w-full">
                <CustomInput
                  type="text"
                  name="serial_number"
                  label={t("organizations.job_postions_lables.serialNumber")}
                  id="Serial number"
                  onKeyDown={handleKeyDownforPositiveNumber}
                  autoComplete="company-name"
                  placeholder={t(
                    "organizations.job_postions_lables.serialNumber"
                  )}
                  register={{ ...control.register("serial_number") }}
                  error={errors?.serial_number}
                  disabled={editmode}
                />
              </div>
            )}

            <div className={`${editmode ? "lg:w-6/12" : ""} w-full`}>
              <CustomInput
                type="text"
                name="Abbreviation"
                label={t("organizations.job_postions_lables.abbreviation")}
                id="Abbreviation"
                onKeyDown={handleKeyDown}
                autoComplete="company-name"
                placeholder={t(
                  "organizations.job_postions_lables.abbreviation"
                )}
                register={{ ...control.register("abbreviation") }}
                error={errors?.abbreviation}
              />
            </div>
          </div>
        </div>
        <div className="lg:w-6/12 w-full">
          <div className="flex lg:flex-row flex-col 2xl:gap-5 gap-3">
            <div className="lg:w-6/12 w-full 2xl:mb-7 mb-3">
              <CustomInput
                type="text"
                name="Coefficient"
                label={t("organizations.job_postions_lables.coefficient")}
                id=" Coefficient"
                onKeyDown={handleKeyDown}
                autoComplete="company-name"
                placeholder={t("organizations.job_postions_lables.coefficient")}
                register={{ ...control.register("difficulty_coefficient") }}
                error={errors?.difficulty_coefficient}
              />
            </div>

            <div className=" lg:w-6/12 w-full">
              <CustomInput
                type="text"
                name="work_experience "
                label={t("organizations.job_postions_lables.workExperience")}
                id="Full name"
                onKeyDown={handleKeyDownforPositiveNumber}
                autoComplete="company-name"
                placeholder={t(
                  "organizations.job_postions_lables.workExperience"
                )}
                register={{ ...control.register("work_experience") }}
                error={errors?.work_experience}
              />
            </div>
          </div>
        </div>
      </div>

      <div className="grid lg:grid-cols-2 grid-cols-1 gap-x-5 2xl:gap-y-7 gap-y-3 2xl:mb-7 mb-3">
        <div className=" 2xl:mt-0 mt-3">
          <CustomInput
            type="text"
            name="Title"
            label={t("organizations.job_postions_lables.title")}
            id="Title"
            onKeyDown={handleKeyDown}
            autoComplete="company-name"
            placeholder={t("organizations.job_postions_lables.title")}
            register={{ ...control.register("name") }}
            error={errors?.name}
          />
        </div>

        <div>
          <Controller
            name="required_knowledge_and_skill_id"
            control={control}
            render={({ field: { onChange, value, ref } }) => (
              <Select
                inputRef={ref}
                isClearable
                options={skilOptions}
                value={
                  skilOptions.find((option) => option?.value === value) || null
                }
                placeholder={t(
                  "organizations.job_postions_lables.mandatorySkills"
                )}
                className={
                  errors.required_knowledge_and_skill_id ? "error" : ""
                }
                onChange={(selectedOption) =>
                  onChange(selectedOption ? selectedOption.value : null)
                }
                styles={customStylesDropdown}
                getOptionValue={(option) => option?.value}
                getOptionLabel={(option) => option?.label}
              />
            )}
          />
          {errors.required_knowledge_and_skill_id && (
            <p className="text-red-600">
              {errors.required_knowledge_and_skill_id.message}
            </p>
          )}
        </div>

        <div className="flex lg:flex-row flex-col gap-x-5">
          <div className=" lg:w-6/12 w-full">
            <div className="mr-7 lg:mb-0 mb-3 w-full">
              <CustomInput
                type="text"
                name="Number of seats (planned no.)"
                label={t("organizations.job_postions_lables.numberOfSeats")}
                id="Number of seats (planned no.)"
                onKeyDown={handleKeyDownforPositiveNumber}
                autoComplete="company-name"
                placeholder={
                  t("organizations.job_postions_lables")
                    .numberOfSeats_placeholder
                }
                register={{
                  ...control.register("allocated_number_of_employees"),
                }}
                error={errors?.allocated_number_of_employees}
              />
            </div>
          </div>

          <div className=" lg:w-6/12 w-full">
            <CustomInput
              type="text"
              name="Min. no. of employees"
              label={t("organizations.job_postions_lables.minEmployees")}
              id="Min. no. of employees"
              onKeyDown={handleKeyDownforPositiveNumber}
              autoComplete="company-name"
              placeholder={t("organizations.job_postions_lables.minEmployees")}
              register={{ ...control.register("minimum_number_of_employees") }}
              error={errors?.minimum_number_of_employees}
            />
          </div>
        </div>

        <div>
          <Controller
            name="special_requirement_id"
            control={control}
            render={({ field: { onChange, value, ref } }) => (
              <Select
                inputRef={ref}
                isClearable
                options={specialRequirmentOptions}
                value={
                  specialRequirmentOptions.find(
                    (option) => option?.value === value
                  ) || null
                }
                placeholder={t(
                  "organizations.job_postions_lables.specialRequirements"
                )}
                className={errors.special_requirement_id ? "error" : ""}
                onChange={(selectedOption) =>
                  onChange(selectedOption ? selectedOption.value : null)
                }
                styles={customStylesDropdown}
                getOptionValue={(option) => option?.value}
                getOptionLabel={(option) => option?.label}
              />
            )}
          />
          {errors.special_requirement_id && (
            <p className="text-red-600">
              {errors.special_requirement_id.message}
            </p>
          )}
        </div>
      </div>

      <div className="flex lg:flex-row flex-col gap-x-5 items-start">
        <div className=" lg:w-6/12 w-full">
          <div className="2xl:mb-7 mb-3">
            <Controller
              name="unit_id"
              control={control}
              render={({ field: { onChange, value, ref } }) => (
                <Select
                  inputRef={ref}
                  isClearable
                  options={unitDropdownOptions}
                  value={
                    unitDropdownOptions.find(
                      (option) => option?.value === value
                    ) || null
                  }
                  placeholder={t(
                    "organizations.job_postions_lables.organizationalUnit"
                  )}
                  className={errors.unit_id ? "error" : ""}
                  onChange={(selectedOption) =>
                    onChange(selectedOption ? selectedOption.value : null)
                  }
                  styles={customStylesDropdown}
                  getOptionValue={(option) => option?.value}
                  getOptionLabel={(option) => option?.label}
                />
              )}
            />
            {errors.unit_id && (
              <p className="text-red-600">{errors.unit_id.message}</p>
            )}
          </div>

          <div className="2xl:mb-7 mb-3">
            <Controller
              name="parent_id"
              control={control}
              render={({ field: { onChange, value, ref } }) => (
                <Select
                  inputRef={ref}
                  isClearable
                  isDisabled={
                    (editmode &&
                      getValues("parent_id") ===
                        "00000000-0000-0000-0000-000000000000") ||
                    !orgUnitID
                  }
                  options={
                    jobPositionDropdownOptions.length
                      ? jobPositionDropdownOptions
                      : [
                          {
                            value: "00000000-0000-0000-0000-000000000000",
                            label: "Top parent",
                          },
                        ]
                  }
                  value={
                    jobPositionDropdownOptions.length
                      ? jobPositionDropdownOptions.find(
                          (option) => option?.value === value
                        ) || null
                      : "00000000-0000-0000-0000-000000000000"
                  }
                  placeholder={t(
                    "organizations.job_postions_lables.parentJobPosition"
                  )}
                  className={errors.parent_id ? "error" : ""}
                  onChange={(selectedOption) =>
                    onChange(selectedOption ? selectedOption.value : null)
                  }
                  styles={customStylesDropdown}
                  getOptionValue={(option) => option?.value}
                  getOptionLabel={(option) => option?.label}
                />
              )}
            />
            {errors.parent_id && (
              <p className="text-red-600">{errors.parent_id.message}</p>
            )}
          </div>

          <div className="2xl:mb-7 mb-3">
            <Controller
              name="location_id"
              control={control}
              render={({ field: { onChange, value, ref } }) => (
                <Select
                  inputRef={ref}
                  isClearable
                  options={locationDropdownOptions}
                  value={
                    locationDropdownOptions.find(
                      (option) => option?.value === value
                    ) || null
                  }
                  placeholder={t("organizations.job_postions_lables.locations")}
                  className={errors.location_id ? "error" : ""}
                  onChange={(selectedOption) => onChange(selectedOption?.value)}
                  getOptionValue={(option) => option?.value}
                  getOptionLabel={(option) => option?.label}
                  styles={customStylesDropdown}
                />
              )}
            />
            {errors.location_id && (
              <p className="text-red-600">{errors.location_id.message}</p>
            )}
          </div>

          <div className="2xl:mb-7 mb-3">
            <Controller
              name="foreign_language_id"
              control={control}
              render={({ field: { onChange, value, ref } }) => (
                <Select
                  inputRef={ref}
                  isClearable
                  options={foreignLangugeOptions}
                  value={
                    foreignLangugeOptions.find(
                      (option) => option?.value === value
                    ) || null
                  }
                  placeholder={t(
                    "organizations.job_postions_lables.languageRequirements"
                  )}
                  className={errors.foreign_language_id ? "error" : ""}
                  onChange={(selectedOption) =>
                    onChange(selectedOption ? selectedOption.value : null)
                  }
                  styles={customStylesDropdown}
                  getOptionValue={(option) => option?.value}
                  getOptionLabel={(option) => option?.label}
                />
              )}
            />
            {errors.foreign_language_id && (
              <p className="text-red-600">
                {errors.foreign_language_id.message}
              </p>
            )}
          </div>

          <div className="2xl:mb-7 mb-3">
            <Controller
              name="educational_qualification_id"
              control={control}
              render={({ field: { onChange, value, ref } }) => (
                <Select
                  inputRef={ref}
                  isClearable
                  options={eduactionQulificationOptions}
                  value={
                    eduactionQulificationOptions.find(
                      (option) => option?.value === value
                    ) || null
                  }
                  placeholder={t(
                    "organizations.job_postions_lables.educationalQualifications"
                  )}
                  className={errors.educational_qualification_id ? "error" : ""}
                  onChange={(selectedOption) =>
                    onChange(selectedOption ? selectedOption.value : null)
                  }
                  styles={customStylesDropdown}
                  getOptionValue={(option) => option?.value}
                  getOptionLabel={(option) => option?.label}
                />
              )}
            />
            {errors.educational_qualification_id && (
              <p className="text-red-600">
                {errors.educational_qualification_id.message}
              </p>
            )}
          </div>
        </div>

        <div className=" lg:w-6/12 w-full">
                <div className="2xl:mb-7 mb-3">
<Controller
  name="violation_timeout"
  control={control}
  render={({ field }) => (
    <div className="2xl:mb-7 mb-3 relative">
      <label className="absolute -top-2 left-2 bg-white px-1 text-xs text-[#003e8f] z-10">
        {t("organizations.job_postions_lables.violationTimeout")}
      </label>
      <input
        type="number"
        min={0}
        {...field}
        className={`border border-gray_100 rounded-[10px] py-2 px-4 w-full ${
          errors?.violation_timeout ? "border-red-500" : ""
        }`}
      />
    </div>
  )}
/>

  {errors.violation_timeout && (
    <p className="text-red-600 text-sm">{errors.violation_timeout.message}</p>
  )}
</div>

          <div className="2xl:mb-7 mb-3">
            <CustomTextArea
              label={t(
                "organizations.job_postions_lables.jobPositionDescription"
              )}
              onKeyDown={handleKeyDown}
              placeholder={t(
                "organizations.job_postions_lables.jobPositionDescription"
              )}
              register={{ ...control.register("description") }}
              className="border border-gray_100 rounded-[10px] py-2 px-4 w-full h-full 2xl:min-h-60 min-h-40 "
              error={errors?.description}
            />
          </div>
        </div>
      </div>

      <div className="flex justify-end bg-gray_50 rounded-[14px] 2xl:py-5 py-3 px-[10px] ">
        <button
          onClick={onClose}
          type="button"
          className="mr-1 border border-primary_orange text-sm  font-semibold font-pop text-primary_orange py-2 px-[26px] rounded-[14px] transition-all ease-in-out duration-300 hover:bg-primary_orange hover:text-white bg-transparent"
        >
          {t("organizations.ou_form_lables.cancelButton")}
        </button>
        <button
          disabled={loading}
          type="submit"
          className=" mr-4  text-sm  font-semibold font-pop text-white border border-transparent hover:border-primary_orange hover:text-primary_orange hover:bg-transparent py-2 px-[26px] rounded-[14px] transition-all ease-in-out duration-300 bg-primary_orange"
        >
          {loading ? (
            <Loader />
          ) : (
            <span> {t("organizations.ou_form_lables.saveButton")}</span>
          )}
        </button>
      </div>
    </form>
  );
}

export default withNamespaces()(AddJobPosition);
